// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__37xCs","notes":"Notes_notes__3VmJn","note":"Notes_note__2jmWj","markdown":"Notes_markdown__AulWh"};